import React, { useEffect, useState } from "react";
import { useGlobalContext } from "../../../context/global";
import {
  FiltersCampaignDataQuadrant,
  FiltersDimensionDataQuadrant,
  FiltersMeasuresDataQuadrant,
  useTopXDataConfig,
} from "../../../components/Filter/FilterData/quadrantFilter";
import { processFields } from "../../../components/Filter/subComponents/filterHelper";
import styles from "../subComponents/productSetFilters.module.css";
import arrowUpIcon from "../../../assets/icons/arrow_up_icon.svg";
import arrowDownIcon from "../../../assets/icons/down_arrow.svg";
import CreateProductSetModal from "./CreateProductSetModal";
import ComplexFilterWidget from "../../../components/Filter/ComplexFilterWidget";
import { FILTER_LAST_7_14_DAYS_OPTIONS } from "../../../components/Filter/filterQuadrantUtils";

const ProductSetFilters = (props) => {
  const { clientId } = useGlobalContext();
  const TopXDataConfig = useTopXDataConfig();
  const userPlatform = JSON.parse(localStorage.getItem("user_platform"));
  const { handleProductSetDetail } = props;
  const [isExpanded, setIsExpanded] = useState(true);
  const [errors, setErrors] = useState(props?.errors);
  const PRODUCT_SET_DATE_OPTIONS = [
    ...FILTER_LAST_7_14_DAYS_OPTIONS,
    { value: "last_30d", label: "Last 30 days", type: "" },
  ];
  const [selectedDay, setSelectedDay] = useState(
    PRODUCT_SET_DATE_OPTIONS.find(
      (option) => option?.value === props?.customDate
    )
  );
  const [productSetDetail, setProductSetDetail] = useState({
    ...props.productSetDetail,
  });

  useEffect(() => {
    setSelectedDay(
      PRODUCT_SET_DATE_OPTIONS.find(
        (option) => option.value === props.customDate
      )
    );
  }, [props.customDate]);

  useEffect(() => {
    setProductSetDetail({ ...props.productSetDetail });
  }, [props.productSetDetail]);

  useEffect(() => {
    const init = async () => {
      const precessedDimensionData = await processFields(
        FiltersDimensionDataQuadrant[userPlatform].fields,
        clientId,
        []
      );
      FiltersDimensionDataQuadrant[userPlatform].fields =
        precessedDimensionData;
      const precessedMeasuresData = await processFields(
        FiltersMeasuresDataQuadrant[userPlatform].fields,
        clientId,
        []
      );
      FiltersMeasuresDataQuadrant[userPlatform].fields = precessedMeasuresData;
      const precessedAmazonData = await processFields(
        FiltersCampaignDataQuadrant[userPlatform].fields,
        clientId,
        []
      );
      FiltersCampaignDataQuadrant[userPlatform].fields = precessedAmazonData;
    };
    init();
  }, [clientId]);

  useEffect(() => {
    setErrors(props.errors);
  }, [props.errors]);

  const productSetName = productSetDetail?.name ?? "";
  const productSetRefreshFrequency = productSetDetail?.refresh_duration ?? "";
  const productSetDeDuplicateASIN = productSetDetail?.de_duplication ?? "";

  return (
    <>
      <div className={styles.pageFilterWrapper}>
        <div
          style={{
            display: "flex",
            padding: isExpanded ? "12px 24px" : "12px 24px",
            justifyContent: "space-between",
            borderBottom: isExpanded ? "1px solid #C9CCCF" : "0px",
          }}
        >
          <div style={{ fontSize: "16px", lineHeight: "1.3", color: "#000" }}>
            Apply Filters
          </div>
          <div onClick={(e) => setIsExpanded(!isExpanded)}>
            <img
              height={10}
              src={isExpanded ? arrowUpIcon : arrowDownIcon}
              alt="up"
            />
          </div>
        </div>
        <div
          style={{
            opacity: isExpanded ? 1 : 0,
            transform: isExpanded ? "scaleY(1)" : "scaleY(0)",
            transformOrigin: "center",
            transition: "opacity 0.3s ease-in-out, transform 0.2s ease-in-out",
            visibility: isExpanded ? "visible" : "hidden",
            maxHeight: isExpanded ? "max-content" : "0", // Adjust based on content's maximum height
          }}
        >
          <ComplexFilterWidget
            config={{
              campaigns: FiltersCampaignDataQuadrant[userPlatform],
              measure: FiltersMeasuresDataQuadrant[userPlatform],
              dimension: FiltersDimensionDataQuadrant[userPlatform],
              topXConfig: TopXDataConfig,
            }}
            filters={props.filterModuleFilters}
            output={props.handleFilterOutput}
            prefixMember={""}
            type="page"
            page={"product-sets"}
            // summary={"onApplied"}
            fetchingData={props.fetchingData}
            setShowPopupModal={setIsExpanded}
            isAppliedCallback={props.handleFilterApplied}
            narrowFilters={true}
            daysOptions={PRODUCT_SET_DATE_OPTIONS}
            selectedDay={selectedDay}
            sidebar={true}
            default={"metrics"}
            showDays={true}
            id={"exclusion"}
            campaignFilter={false}
            handleSelectedDay={props.handleCustomDate}
            calloutTitle="Select your filters"
            calloutContent="+ Add Filter"
            hideFilterSummary={true}

          />
        </div>
      </div>

      <CreateProductSetModal
        open={props.show}
        onClose={props.handleClose}
        onSave={props.onSave}
        isSaving={props.isSaving}
        productSetCreationId={props.productSetCreationId}
        productSetName={productSetName}
        productSetRefreshFrequency={productSetRefreshFrequency}
        productSetDeDuplicateASIN={productSetDeDuplicateASIN}
        handleProductSetDetail={handleProductSetDetail}
        errors={errors}
        productsetId={props.productsetId}
        userPlatform={userPlatform}
      />
     
    </>
  );
};

export default ProductSetFilters;
